import {
  COMPARISON_OPERATORS,
  FORM_STATUS_ID,
} from '@witmetrics/utils/constants';
import { buildColumnFilter } from '@witmetrics/utils/filters';
import type { UndecoratedForm } from '@witmetrics/utils';
import { searchByKeys } from '@witmetrics/utils/arrays';
import { API } from '@/api';

export const classes = {
  paper: 'fixed top-8 rounded-2xl',
  wrapper: 'flex flex-col w-[90vw] max-w-[800px] min-w-[200px] min-h-0',
  inputBase: 'w-full text-2xl px-6 py-4 flex-0',
  recentlyViewedWrapper: 'place-between px-6 py-0',
  recentlyViewed: 'text-base text-grey-8 dark:text-mauve-1 font-medium',
  clearButton:
    'text-grey-7 dark:text-mauve-2 hover:text-grey-8 dark:hover:text-mauve-1',
  resultsList: 'flex-0 max-h-[40vh] overflow-auto',
  recentList: 'pt-0 mt-0',
  message: 'text-grey-7 dark:text-mauve-2 text-center text-lg py-8',
};

export async function fetchPracticeForms(practiceId: number) {
  // Only fetch forms that are currently active
  return (
    await API.Practices.fetchPracticeForms(practiceId, {
      pagination: { page: 1, pageSize: 100 },
      filters: [
        buildColumnFilter(
          'formStatusId',
          COMPARISON_OPERATORS.EQUALS.value,
          FORM_STATUS_ID.ACTIVE
        ),
      ],
    })
  ).results;
}

export function filterForms(forms: UndecoratedForm[], query: string) {
  return searchByKeys(forms, ['name', 'description'], query);
}
